import { createHead } from "@vueuse/head";
export default createHead();
